import React from 'react';
import ImgIconComp from '../imgcomp';

class GrpMeetingAttendeeList extends React.Component {
  constructor(props) {
    super(props);
    this.updateMeetingAccess = this.updateMeetingAccess.bind(this);
  }

  updateMeetingAccess(event) {
    const checkedVal = event.target.checked == true ? 1 : 0;
    this.props.updateMeetingAccessState(this.props.userId, checkedVal);
  }

  render() {
    const randNum = Math.floor(Math.random() * 10000000) + 1;
    const userVal = `${this.props.userId}_${randNum}`;
    const userIdInpName = `meetingSelectedUser[${userVal}][userId]`;
    const userAccessInpName = `meetingSelectedUser[${userVal}][userAccess]`;
    const userTeamInpName = `meetingSelectedUser[${userVal}][teamId]`;
    const userSelected = this.props.userAccess == 1;
    const chkBxId = `grp-meeting-attendee-select-${this.props.userId}`;

    return (
      <div className="displayTable padTop10 tabLayFix width100">
        <div className="grp-meeting-attendee-row displayRow">
          <div className="grp-meeting-attendee-ckbox displayCell">
            <input
              type="checkbox"
              id={chkBxId}
              className="grp-meeting-attendee-select"
              onChange={event => this.updateMeetingAccess(event)}
              checked={userSelected}
            />
            <label htmlFor={chkBxId} />
          </div>
          <div className="grp-meeting-attendee-avatar displayCell">
            <ImgIconComp class="roundFramePhoto team-meeting-attendee-pic fitProfileImage" srcUrl={this.props.userPic} width="35" height="35" />
          </div>
          <div className="grp-meeting-user-det displayCell">
            <div className="grp-meeting-user-name truncateText">
              {this.props.userName}
            </div>
          </div>
        </div>
        <input type="hidden" id={userIdInpName} name={userIdInpName} value={this.props.userId} />
        <input type="hidden" id={userAccessInpName} name={userAccessInpName} value={this.props.userAccess} />
        <input type="hidden" id={userTeamInpName} name={userTeamInpName} value={this.props.userTeam} />
      </div>
    );
  }
}
export default GrpMeetingAttendeeList;
